<template>
  <div id="index">
    <el-row v-loading="loading" v-for="(item, k) in showList" :key="k">
      <el-col :span="24">
        <h3 :class="item.class">～～～～ {{item.name}} ～～～～</h3>
      </el-col>

      <el-col :span="6" v-for="(o, index) in item.data" :key="index" style="padding: 5px">
        <el-card :body-style="{ padding: '8px'}" @click.native="showDetail(o.id)" shadow="never">
          <div style="width: 100%;text-align: center;height: 150px;overflow: hidden;">
            <img v-lazyload src="../../static/loading.svg" :data-src="o.cover" class="app-image" data-err="../../static/df.png">
          </div>
          <div style="padding: 5px;">
            <p class="post_title">
              <span class="post_meta_top">
                【{{ o.city }}】
              </span>
              {{ o.title }}
            </p>
            <p>
              <el-rate
                v-model="o.score"
                disabled>
              </el-rate>
            </p>
            <p class="post_meta_top" style="color:#888;font-size: 14px;">
              <i class="icon fa fa-comments"  style="color:#409EFF">
              </i>
              {{o.commentsLen}}

              <span style="float: right">
                <i class="icon fa fa-bitcoin" style="color:goldenrod">
                </i>
                {{o.valueNas}} nas
              </span>
            </p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div style="text-align: right;margin-top: 10px;">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="changePage"
        :current-page.sync="pageInfo.current"
        :page-size="pageInfo.size"
        :total="pageInfo.total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import {mapState} from 'vuex'
import _ from 'lodash'
import nebulas from 'nebulas'

export default {
  data () {
    return {
      loading: false,
      pageInfo: {current: 1, size: 4},
      listAll: [],
      showList: {
        'hot': {name: '最热', class: 'hot-title', data: []},
        'normal': {name: '最新', class: 'all-title', data: []}
      }
    }
  },
  methods: {
    // 查看详情
    showDetail: function (id) {
      this.$router.push({name: 'detail', query: {id: id}})
    },
    // 获取列表
    getList (o) {
      var vueThis = this
      vueThis.loading = true;
      vueThis.$store.dispatch('simulateCallNew', {funcName: 'getAllFoods'}).then((ret) => {
        let data = JSON.parse(ret);

        vueThis.listAll = data;
        // 循环初始化
        _.forEach(vueThis.listAll, function (item) {
          let d = new Date(item.ct)
          item.ctDes = d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
          item.commentsLen = item.comments.length;

          item.valueNas = nebulas.Unit.fromBasic(item.value, 'nas');
          item.valueNas = _.replace(item.valueNas, '"', '');
        });
        // 最新排序
        vueThis.listAll = _.orderBy(vueThis.listAll, ['ct'], ['desc']);
        // 最热排序
        let hotSort = _.orderBy(vueThis.listAll, function (item) {
          return item.comments.length;
        }, ['desc']);
        vueThis.showList['hot'].data = _.slice(hotSort, 0, vueThis.pageInfo.size);

        vueThis.loading = false;
        vueThis.changePage(1);
      }, (error) => {
        vueThis.loading = false;
        vueThis.showErr('获取书评列表失败' + error);
      });
    },
    // [所有]修改页码
    changePage (pageNum) {
      let vueThis = this;
      vueThis.loading = true;
      vueThis.showList['normal'].data = [];
      // 分页处理
      let p = vueThis.pageInfo;
      p.current = !pageNum ? 1 : pageNum;
      let maxPage = Math.ceil(p.total / p.size);
      p.current = _.min([p.current, maxPage])
      p.total = _.get(vueThis.listAll, 'length', 0);

      let start = (p.current - 1) * p.size;
      let end = _.min([p.current * p.size, p.total]);

      vueThis.showList['normal'].data = _.slice(vueThis.listAll, start, end);
      vueThis.loading = false;
    }
  },
  created () {
    this.getList()
  },
  computed: mapState([
    'user'
  ])
}
</script>

<style>
  #index{
  }

  #index .hot-title{
    padding: 10px;
    background-color: rgba(255, 69, 0, 0.68);
    color: white;
    text-align: center;
  }
  #index .all-title{
    padding: 10px;
    background-color: rgba(0, 186, 189, 1);
    color: white;
    text-align: center;
  }

  #index .app-image{
    max-width: 100%;
    margin-bottom: 10px;
    object-fit: cover;
    transition:all .4s;
    vertical-align: middle;
    border-style: none;
  }

  #index .app-image:focus, #index .app-image:hover{
    transform: scale(1.05);
  }

  #index .post_title {
    color: #4c4c4c;
    font-weight: 400;
    font-size: 12px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  #index .post_meta_top {
    color: #999;
    font-weight: 400;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/base-index.vue